module.exports = __webpack_public_path__ + "static/media/plants2.0a1d847e.jpg";